// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"

// Import all controllers
import HelloController from "./hello_controller"
import DaisyController from "./daisy_controller"
import AlertController from "./alert_controller"
import ConfirmDeleteController from "./confirm_delete_controller"
import SortableController from "./sortable_controller"
import ClipboardController from "./clipboard_controller"
import TabsController from "./tabs_controller"
import ImageUploadController from "./image_upload_controller"
import CarouselController from "./carousel_controller"
import MapController from "./map_controller"
import ExtensionConnectController from "./extension_connect_controller"

// Register controllers
application.register("hello", HelloController)
application.register("daisy", DaisyController)
application.register("alert", AlertController)
application.register("confirm-delete", ConfirmDeleteController)
application.register("sortable", SortableController)
application.register("clipboard", ClipboardController)
application.register("tabs", TabsController)
application.register("image-upload", ImageUploadController)
application.register("carousel", CarouselController)
application.register("map", MapController)
application.register("extension-connect", ExtensionConnectController)
